import { useEffect, useState } from 'react'

import { useFileDownload } from '../../File'
import { ICON_HEIGHT_40, IconSpinner } from '../../Icon'
import { PdfViewer } from '../../PdfViewer'
import { FILES_PREVIEW_PDF_PERMANENT_API_PARAMS } from '../FilesPreviewGallery.constants'

import { PDF_TEMPLATE_PREVIEW_FETCH_INTERVAL } from './PdfTemplatePreview.constants'

import * as styles from './PdfTemplatePreview.module.css'

function PdfTemplatePreview({
  className = styles.PdfTemplatePreview,
  file: pdf,
}) {
  const [file, setFile] = useState(pdf)

  const { downloadFile, loading } = useFileDownload({
    apiParams: FILES_PREVIEW_PDF_PERMANENT_API_PARAMS,
    file: pdf,
    interval: PDF_TEMPLATE_PREVIEW_FETCH_INTERVAL,
    onLoad: origin => setFile(prevValue => ({ ...prevValue, origin })),
  })

  useEffect(downloadFile, [])

  return !file || loading ? (
    <IconSpinner size={ICON_HEIGHT_40} />
  ) : (
    <div className={className}>
      <PdfViewer file={file} />
    </div>
  )
}

export default PdfTemplatePreview
